import { Link } from "@tanstack/react-router";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PublicNavbar } from "@/components/public-navbar";
import { SeoHead } from "@/components/seo-head";
import { JsonLd } from "@/components/json-ld";
import { FAQ_SECTIONS, buildFaqPageSchema } from "@/lib/faq-schema";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function FaqPage() {
  return (
    <div className="min-h-screen bg-background">
      <SeoHead
        title="Frequently Asked Questions"
        description="Answers to common questions about TodoLLM billing, organizations, roles, and task management for hybrid human-AI teams."
        canonical="https://todollm.com/faq"
      />
      <JsonLd data={buildFaqPageSchema()} />
      <PublicNavbar />
      <main className="mx-auto max-w-3xl px-6 py-16">
        <header className="mb-8 space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary">
            FAQ
          </p>
          <h1 className="text-3xl font-bold tracking-tight">
            Frequently asked questions
          </h1>
          <p className="text-sm text-muted-foreground">
            Don't see your question?{" "}
            <Link
              to="/contact"
              className="font-medium text-foreground underline-offset-4 hover:underline"
            >
              Contact us
            </Link>
            .
          </p>
        </header>

        <div className="space-y-8">
          {FAQ_SECTIONS.map((section) => (
            <section key={section.title} className="space-y-3">
              <h2 className="text-lg font-semibold tracking-tight">
                {section.title}
              </h2>
              <div className="space-y-3">
                {section.items.map((item) => (
                  <Card key={item.q}>
                    <CardHeader>
                      <CardTitle className="text-base">{item.q}</CardTitle>
                    </CardHeader>
                    <CardContent className="text-sm leading-6 text-muted-foreground">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {item.a}
                      </ReactMarkdown>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
}
